import type React from "react";

import type { DesignSystemElementProps } from "./contracts/dom";

export type HiddenInputProps = Omit<DesignSystemElementProps<"input">, "type"> & {
  ref?: React.Ref<HTMLInputElement>;
};

/** Carries form state without introducing a visible control. */
export function HiddenInput({ ref, ...props }: HiddenInputProps): React.ReactNode {
  return <input {...props} ref={ref} type="hidden" />;
}
